import { combineReducers } from 'redux'

import AppReducer from './App/AppReducer'
import AuthReducer from './App/AuthReducer'
import ActiveProjectPageReducer from './ActiveProjectPage/ActiveProjectPageReducer'
import ProjectDocumentPageReducer from './ProjectDocumentPage/ProjectDocumentPageReducer'
import TemplateListPageReducer from './TemplateListPage/TemplateListPageReducer'
import TemplateEditPageReducer from './TemplateEditPage/TemplateEditPageReducer'
import ProfilePageReducer from './ProfilePage/ProfilePageReducer'
import UserManagementPageReducer from './UserManagementPage/UserManagementPageReducer'

const rootReducer = combineReducers({
    app: AppReducer,
    auth: AuthReducer,
    activeProjectPage: ActiveProjectPageReducer,
    projectDocumentPage: ProjectDocumentPageReducer,
    templateListPage: TemplateListPageReducer,
    templateEditPage: TemplateEditPageReducer,
    profilePage: ProfilePageReducer,
    userManagementPage: UserManagementPageReducer
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/Reducers.js